// Undo/redo keyboard shortcut resolution for EditorApp.keyListener.
//
//   Ctrl/⌘ + Z          → undo
//   Ctrl/⌘ + Shift + Z  → redo  (was wrongly treated as undo: the old check was
//                                `key === Z && ctrlKey` with no Shift test)
//   Ctrl + Y            → redo  (Ctrl only — ⌘Y opens History in Chrome on macOS)
//
// Alt-modified combos are ignored: on Windows AltGr reports Ctrl+Alt, so
// AltGr+Z / AltGr+Y are character input, not commands.
const KEY_Y = 89;
const KEY_Z = 90;

export function getUndoRedoIntent(e) {
  if (!e || e.altKey) return null;
  const key = e.keyCode ? e.keyCode : e.which;
  if (key === KEY_Z && (e.ctrlKey || e.metaKey)) {
    return e.shiftKey ? "redo" : "undo";
  }
  if (key === KEY_Y && e.ctrlKey && !e.shiftKey) {
    return "redo";
  }
  return null;
}

// True when the focused element is an inline text surface (contentEditable).
// The keyListener's legacy `notText` heuristic only catches form fields and
// CKEditor; a plain contentEditable (e.g. inline assessment option text) would
// otherwise get the browser's native text undo AND a canvas-wide Redux undo.
export function isContentEditableFocus(el) {
  if (!el) return false;
  if (el.isContentEditable) return true;
  if (typeof el.getAttribute === "function") {
    const attr = el.getAttribute("contenteditable");
    if (attr === "" || attr === "true") return true;
  }
  return false;
}
